import {request, setAuthInHeader} from "@/api/request";
import util from "@/mixins/util";
import {logout, getTokenObj} from "@/mixins/Auth";

const state = {
    UserInfo: {},
};

const getters = {
    getUserInfo: state => state.UserInfo,

};

const mutations = {
    updateUserInfo(state, obj) {
        state.UserInfo = obj.value;
    },
    resetUserInfo(state) {
        state.UserInfo = {};
    },
};

const actions = {
    async setUserInfo({ commit }, { token }) {
        try {
            setAuthInHeader(token);
            const tokenObj = getTokenObj();
            if (!tokenObj) return;

            const url = 'v1/admin/member/my-info';
            const params = {};

            const res = await request.javaGet(url, params); // ✅ await 사용

            if (!res) return false;

            const result = res.data;
            if (result.code > 0 && !util.isEmpty(result.result.data)) {
                commit('updateUserInfo', { value: {...tokenObj, ...result.result.data} }); // ✅ await 필요 없음
                return true; // ✅ 성공 결과 반환
            } else {
                console.warn('응답 결과 없음');
                return false;
            }
        } catch (e) {
            console.error('setUserInfo 오류:', e);
            return false;
        }
    },
    changeUserInfo({commit, rootState}, {data}) {
        commit('updateUserInfo', {'value': data});
    },
    initUserInfo({commit, rootState}, {data}) {
        commit('resetUserInfo');
    },

};

export default {namespaced: true, state, getters, mutations, actions}
